import { render } from "./HelloSante.vue?vue&type=template&id=a13ac8de&scoped=true"
import script from "./HelloSante.vue?vue&type=script&lang=js"
export * from "./HelloSante.vue?vue&type=script&lang=js"

import "./HelloSante.vue?vue&type=style&index=0&id=a13ac8de&lang=css"
import "./HelloSante.vue?vue&type=style&index=1&id=a13ac8de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a13ac8de"]])

export default __exports__